import React, { Suspense } from "react";
import Preloader from "../elements/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import Kvkk from "../components/Kvkk"
import FooterThree from "../components/FooterThree";

const KvkkPage = () => {
  
  return (
    <>
      <Suspense fallback={<Preloader />}>
        <HeaderOne />
        <main>
          <Breadcrumb title="KVKK Aydınlatma Metni" />
          <Kvkk />
        </main>
        <FooterThree />
      </Suspense>
    </>
  );
  

};


export default KvkkPage;
